// @flow

import * as React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Icon from '@mui/material/Icon';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import i18n from 'app/common/i18n';
import Button from 'app/common/button';

class InfoModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: false
    };
  }

  handleClose = () => this.setState({ modal: false });

  handleClick = () => {
    return this.setState({ modal: true });
  };

  render() {
    const actions = [
      <Button
        key="close"
        primary
        autoFocus
        label={this.props.i18n('Close')}
        onClick={this.handleClose}
        style={{ marginLeft: '12px' }}
      />
    ];

    return (
      <div>
        {this.state.modal ? (
          <Dialog
            open
            fullWidth
            fullScreen={this.props.fullScreen}
            onClose={this.handleClose}
            className={'dialog-common'}
          >
            <DialogTitle>{this.props.title}</DialogTitle>
            <DialogContent>{this.props.message}</DialogContent>
            <DialogActions>{actions}</DialogActions>
          </Dialog>
        ) : null}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
          onClick={this.handleClick}
        >
          {this.props.label}
          <Icon>info</Icon>
        </div>
      </div>
    );
  }
}

const InfoModalI18n = i18n(InfoModal);

function InfoModalWithMobileDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return <InfoModalI18n {...props} fullScreen={fullScreen} />;
}

export default InfoModalWithMobileDialog;